window.firstRender = true;

$(document).ready(function(){
  megamenu();
  swipers();
  qtySelectors();
  layoutChanger();
  loading();
  infinteListing();
  registrationForm();
  addressForm();
  storeLocator();
  wishlist();
  announcement();
  phoneInputs();
  cartDrawer();
  zapietWidgetInit();
  announcementBar();
  photoSwipe();
  scrollVariant();
});
const E_EMAIL = 1;
const E_PHONE = 2;
const E_PASSWORD = 3;
const E_REQUIRED = 4;
const E_EMAILINVALID = 5;
const E_GENERIC = 6;
const E_LENGTH = 7;

function cartDrawer(){
  $('[data-cart-remove]').on('click', function(e){
    e.preventDefault();
    loading();
    var url = $(this).attr('data-cart-remove');
    var el = this;
    $.get(url, function(data){
      var cart = $(data).find('#cart-drawer');
      $('#cart-drawer').html($(cart).html());
      cartDrawer();
      loading();
    });
  });
}



function zapietWidgetInit() {
  if(typeof(Zapiet) == 'undefined'){
      return;
  }
  const body = $('body');
  if (body.hasClass('template-cart')) {
    setTimeout(() => {
      if (window.Shopify.locale === 'it' && window.Shopify.country == 'IT') {
        Zapiet.show(["pickup", "delivery"]);
        initializeZapietApp();
      } else {
        Zapiet.hide();
      }

      if(window.ZapietEvent) {
        window.ZapietEvent.listen("selected_method", function(checkout_method) {     
          if(checkout_method == 'shipping'){             
            window.location.href ='/checkout';
          }
        });
      }      
    }, 600);
  }
}

function debounce(func, wait) {  
  let timeout;
  return function () {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function scrollVariant(){    
    const scrollNavigation = document.querySelector('.gift-card-pdp .product-single .mobile-variant-navigation');
    const scrollLeft = document.querySelector('.gift-card-pdp .product-single .mobile-variant-navigation .scroll-left');
    const scrollRight = document.querySelector('.gift-card-pdp .product-single .mobile-variant-navigation .scroll-right');
    const overContainer = document.querySelector('.gift-card-pdp .product-single .product-options');

      if (overContainer.scrollWidth > overContainer.clientWidth) {
        scrollNavigation.style.display = 'flex';
      } else {
        scrollNavigation.style.display = 'none';
      }

      if(scrollLeft && scrollRight && overContainer){
        scrollLeft.addEventListener("click", function() {
        overContainer.scrollBy({ left: -100, behavior: 'smooth' });
      });

      scrollRight.addEventListener("click", function() {
        overContainer.scrollBy({ left: 100, behavior: 'smooth' });
      });
    }
}



function megamenu(){
  $('[data-megamenu-link]').on('mouseover', function(){
    var id = $(this).attr('href');
    $('[data-megamenu]').removeClass('open');
    $('[data-megamenu-link]').removeClass('active');
    if($(id).length){
      $(this).addClass('active');
      $(id).addClass('open');
    }
  });

  $('[data-megamenu]').on('mouseleave', function(){
    $('[data-megamenu-link]').removeClass('active');
    $('[data-megamenu]').removeClass('open');
  });
}

function swipers(){
  $('[data-swiper]').each(function(){
    var name = $(this).attr('data-swiper');
    var opt = {
      autoHeight: false
    };
    if($(this).attr('data-swiper-loop') != undefined){
      opt.loop = true;
    }
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        draggable: true,
        dynamicBullets: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
      opt.spaceBetween = 0;
    }
    try{
      var swiper = new Swiper(this, opt);
  
      $('[data-swiper-to="'+name+'"]').on('click', function(){
        var index = parseInt($(this).attr('data-swiper-index'));
        swiper.slideTo(index);
      });
    } catch{
      console.log('error with swiper');
    }
  });
}

function qtySelectors(){
  $('[data-quantity]').each(function(){
    qtySelector(this);
  });

  function qtySelector(el){
    var minus = $(el).find('[data-quantity-minus]').first();
    var plus = $(el).find('[data-quantity-plus]').first();
    var input = $(el).find('[data-quantity-input]').first();
    var sendForm = $(el).attr('data-quantity-update') !== undefined;

    $(minus).on('click', function(){
      setValue(false);
    });

    $(plus).on('click', function(){
      setValue(true);
    });

    $(input).on('blur', function(){
      setValue();
    });

    function setValue(add){
      var val = parseInt($(input).val());
      var old = parseInt($(input).val());
      if(!isNaN(val)){
        if(add === true)
          val = val + 1;
        else if(add === false)
          val = val - 1;
  
        if(val > 0){
          $(input).val(val);
        }
      } else {
        val = 1;
        $(input).val(val);
      }
      if(old != val && sendForm){
        $(el).parents('form').trigger('submit');
      }
    }
  }
}

function layoutChanger(){
  $('[data-d-layout]').on('click', function(){
    var layout = $(this).attr('data-d-layout');
    changeLayout('d_columns', layout);
  });
  $('[data-m-layout]').on('click', function(){
    var layout = $(this).attr('data-m-layout');
    changeLayout('m_columns', layout);
  });

  function changeLayout(attrname, value){
    loading();
    var fdata = new FormData();
    fdata.append('attributes['+attrname+']', value);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: fdata,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        location.reload();
      },
      error: function (err) {
        console.log(err);
        loading();
      }
    });
  }
}

function loading(id){
  if(id == null)
    id = 'page-loading';
  var loader = $('#'+id);
  $(loader).toggleClass('d-none');
}

function infinteListing(){
  if($('.listing').length){

    $('[data-pager]').on('click', function(){
      loadMore(this);
    });

    var observer = new IntersectionObserver(function(entries){
      $(entries).each(function(){
        if(this.isIntersecting){
          loadMore(this.target);
        }
      });
    }, {threshold: [0.9]});

    var scrollObserver = new IntersectionObserver(function(entries){
      $(entries).each(function(){
        if(this.isIntersecting){
          const params = new URLSearchParams(window.location.search);

		  if (!window.firstRender) {
			  params.set("page", $(this.target).attr("data-pager-page"));
		  }

		  if (window.firstRender) {
			  window.firstRender = false;
		  }
		  
		  window.history.replaceState(
			  {},
			  "",
			  decodeURIComponent(`${window.location.pathname}${params.size ? `?${params}` : ""}`)
		  );
        }
      });
    }, {threshold: [0.9]});

    $('[data-pager]').each(function(){
      observer.observe(this);
    });

    $('[data-pager-page]').each(function(){
      scrollObserver.observe(this);
    });
  
    function loadMore(btn){
      $(btn).parents('.load-more').toggleClass('loading');
      var url = $(btn).attr('data-pager');
      $.get(url, function(data){
        var items = $(data).find('.listing > *');
        console.log(items.length);
        var next = $(data).find('#listing-next');
        var prev = $(data).find('#listing-prev');
        window.history.pushState({"html":data,"pageTitle":$(data).find('title').text()},"", url);
        if($(btn).attr('data-pager-next') != undefined)
          $('.listing').append(items);
        else
          $('.listing').prepend(items);

        if($(next).length){
          $('#listing-next').attr('data-pager', $(next).attr('data-pager'));
        } else {
          $('#listing-next').parents('.load-more').remove();
        }

        if($(prev).length){
          $('#listing-prev').attr('data-pager', $(prev).attr('data-pager'));
        } else {
          $('#listing-prev').parents('.load-more').remove();
        }

        $('[data-pager-page]').each(function(){
          scrollObserver.observe(this);
        });
        wishlist();
        $(btn).parents('.load-more').toggleClass('loading');
      });
    }
  }
}

function registrationForm(){
  var registrationForm = $('#registration-form');
  var accountForm = $('#edit-form');

  
  $('[data-input-tag]').on('blur', function(){
    setTag($(this).parents('form'));
  });
  $('[data-input-tag]').on('change', function(){
    setTag($(this).parents('form'));
  });

  function setTag(form){
    var tags = [];
    $(form).find('[data-input-tag]').each(function(){
      var val = $(this).val();
      var tag = $(this).attr('data-input-tag')+val;
      if($(this).attr('type') == 'checkbox' && $(this).is(':checked')){
        tags.push(tag);
      } else if($(this).attr('type') != 'checkbox') {
        if(val != undefined && val != '' && val != null){
          tags.push(tag);
        }
      }
    });
    $('#tags').val(tags.join(','));
  }

  $(registrationForm).find('[data-form-submit]').on('click', function(){
    sendForm(registrationForm, registrationSuccess);
  });

  $(accountForm).find('[data-form-submit]').on('click', function(){
    sendForm(accountForm, accountSuccess);
  });

  function registrationSuccess(){
    Swal.fire({
      title: errorTranslations.success,
      confirmButtonText: errorTranslations.btn
    }).then((result) => {
      location.href = '/account/login';
    });
  }

  function accountSuccess(){
    Swal.fire({
      title: accountMSG,
      confirmButtonText: errorTranslations.btn
    }).then((result) => {
      location.reload();
    });
  }

  function sendForm(form, callback){
    setTagInputs(form);
    $(form).find('[data-phone-input]').each(function(){
      var phone = window.intlTelInputGlobals.getInstance(this);
      $(this).parents('.form-group').find('[data-phone-value]').val(phone.getNumber(intlTelInputUtils.numberFormat.E164));
    });
    if($(form).attr('data-form-custom') == undefined){
      $(form).trigger('submit');
    } else {
      loading();
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        data: new FormData($(form).get(0)),
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          console.log(data);
          if(data.errors.length){
            var msg = [];
            $(data.errors).each(function(){
              msg.push('<li>'+getInputLabel(form, this[0])+": "+getErrorMessage(this[1])+'</li>');
            });
            Swal.fire({
              title: errorTranslations.title,
              html: '<ul>'+msg.join('')+'</ul>',
              confirmButtonText: errorTranslations.btn
            });
          } else {
            callback();
          }
          loading();
        },
        error: function (err) {
          console.log(err);
          Swal.fire({
            title: errorTranslations.title,
            text: getErrorMessage(E_GENERIC),
            confirmButtonText: errorTranslations.btn
          });
          loading();
        }
      });
    }
  }

  function setTagInputs(form){
    $(form).find('[data-form-hidden]').each(function(){
      var val = $(this).attr('data-form-hidden');
      var parent = $(this).parents('.col-12');
      var input = $(parent).find('[data-form-input]');
      var array = $(parent).find('[data-form-array]');
      var name = $(parent).find('[data-form-name]');
      if($(input).length){
        $(this).val(val + $(input).val());
      }
      else if($(array).length){
        var v = [];
        $(array).each(function(){
          if($(this).is(':checked')){
            v.push($(this).val());
          }
        });
        $(this).val(val + v.join(','));
      }
      else if($(name).length){
        var v = "";
        $(name).each(function(){
          if($(this).is(':checked')){
            v = $(this).val();
          }
        });
        $(this).val(val + v);
      }
    });
  }

  function getInputLabel(form, name){
    var input = $(form).find('[data-input-name="'+name+'"]').first();
    return $(input).attr('data-input-label');
  }

  function getErrorMessage(error){
    var msg = errorTranslations.generic;
    switch(error){
      case E_EMAIL: msg = errorTranslations.email; break;
      case E_PHONE: msg = errorTranslations.phone; break;
      case E_PASSWORD: msg = errorTranslations.password; break;
      case E_REQUIRED: msg = errorTranslations.required; break;
      case E_EMAILINVALID: msg = errorTranslations.invalid_email; break;
      case E_LENGTH: msg = errorTranslations.length; break;
    }
    return msg;
  }
}

function addressForm(){
  $('.address-form').each(function(){
    address(this);
  });

  function address(form){
    var province = $(form).find('[data-province-select]');
    var country = $(form).find('[data-country-select]');
    setProvince();

    $(country).on('change', setProvince);
    function setProvince(){
      try {
        var provinces = JSON.parse($(country).find('option:selected').attr('data-provinces'));
        if(provinces.length){
          var p = ['<option value=""></option>'];
          $(provinces).each(function(){
            p.push('<option value="'+this[0]+'">'+this[0]+'</option>');
          });
          $(province).html(p.join(''));
        } else {
          $(province).html("");
        }
      } catch{
        $(province).html("");
      }
    }
  }

}

function storeLocator(){
  var filtered = [];
  if($('#map').length){
    var lat = Number($('#map').attr('data-latitude'));
    var long = Number($('#map').attr('data-longitude'));
    var zoom = parseInt($('#map').attr('data-zoom'));
    var map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: lat, lng: long },
      mapTypeId: 'roadmap',
      zoom: zoom,
    });
    var sTypes = [];
    var sCountries = [];
    var sCities = [];
    
    for(var i=0;i<stores.length;i++){
      var latLng = new google.maps.LatLng(stores[i].latitude, stores[i].longitude);
      if(stores[i].type == "Flagship"){
        var marker_icon = {url:'//cdn.shopify.com/s/files/1/0583/2586/0558/t/22/assets/flagship_small.png?v=14899692926096937991685431562', scaledSize: new google.maps.Size(15,15)};
      }else if(stores[i].type == "Retail"){
        var marker_icon = {url:'//cdn.shopify.com/s/files/1/0583/2586/0558/t/22/assets/retail_small.png?v=164268853515360238871685431592', scaledSize: new google.maps.Size(15,15)};
      }else if(stores[i].type == "Outlet"){
        var marker_icon = {url:'//cdn.shopify.com/s/files/1/0583/2586/0558/t/22/assets/outlet_small.png?v=168852587313063893881685431606', scaledSize: new google.maps.Size(15,15)};
      }else if(stores[i].type == "Boutique"){
        var marker_icon =  {url:'//cdn.shopify.com/s/files/1/0583/2586/0558/t/22/assets/boutique_small.png?v=14899692926096937991685431635', scaledSize: new google.maps.Size(15,15)};
      } 
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: stores[i].name,
        icon: marker_icon,
        optimized: true,
        url: stores[i].link,
      });
      stores[i].marker = marker;
      google.maps.event.addListener(stores[i].marker, 'click', function() {
        window.location.href = this.url;
      });
    }

    $('[data-locator-filter]').on('change', function(){
      filterStores($(this).attr('data-locator-filter'), $(this).val());
    });
  }

  function filterStores(type){
    var selected = $('[data-locator-filter="'+type+'"]:checked');
    var filters = [];
    $(selected).each(function(){
      filters.push($(this).val());
    });
    if(type == 'type')
      sTypes = filters;
    else if(type == 'country')
      sCountries = filters;
    else if(type == 'city')
      sCities = filters;

    $(stores).each(function(){
      var show = (sTypes.length == 0 || inArray(this.type, sTypes)) && (sCountries.length == 0 || inArray(this.country_code, sCountries)) && (sCities.length == 0 || inArray(this.city, sCities));
      var el = $('[data-store-id="'+this.id+'"]');
      if(show){
        this.marker.setMap(map);
        $(el).removeClass('d-none');
      } else {
        this.marker.setMap(null);
        $(el).addClass('d-none');
      }
    });
    
    
  }
}

function wishlist(){
  $('[data-wishlist]').each(function(){
    productWishlist(this);
  });

  $('[data-wishlist-resync]').each(function(){
    resync();
  });

  $('[data-wishlist-clear]').on('click', function(){
    clearWishlist();
  });

  function resync(){
    var wl = getWishlist();
    if(wl.length > 0){
      saveWishlist(wl, location.reload());
    }
  }

  function clearWishlist(){
    loading();
    localStorage.removeItem('wishlist');
    saveWishlist([], location.reload());
  }

  function getWishlist(){
    var storage = localStorage.getItem('wishlist');
    if(storage != null){
      var wl = JSON.parse(storage);
      if(wl.constructor !== Array){
        wl = [];
      }
    } else {
      wl = [];
    }
    return wl;
  }
  
  function saveWishlist(wl, callback){
    var attr = [];
    $(wl).each(function(){
      attr.push(this.handle+":"+this.variant);
    });
    var fdata = new FormData();
    fdata.append('attributes[wishlist]', attr.join(','));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: fdata,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        callback();
      },
      error: function (err) {
        console.log(err);
        loading();
      }
    });
  }

  function productWishlist(el){
    var btnAdd = $(el).find('[data-wishlist-add]');
    var btnRemove = $(el).find('[data-wishlist-remove]');
    var reload = $(el).attr('data-wishlist-reload') != 'false';

    var handle = $(el).attr('data-wishlist-handle');
    var variant = $(el).attr('data-wishlist-variant');

    $(btnAdd).off().on('click', function(){
      addWishlist();
    });
    $(btnRemove).off().on('click', function(){
      removeWishlist();
    });
  
    function addWishlist(){
      if(reload)
        loading();
      var wl = getWishlist();
      var item = {
        handle: handle,
        variant: variant,
      };
      var add = true;
      $(wl).each(function(){
        if(this.handle.localeCompare(item.handle) == 0 && this.variant == item.variant){
          add = false;
        }
      });
      if(add){
        wl.push(item);
      }
      localStorage.setItem('wishlist', JSON.stringify(wl));
      saveWishlist(wl, function(){
        if(reload)
          location.reload();
        else
          wishlistSaved();
      });
    }
  
    function removeWishlist(){
      if(reload)
        loading();
      var wl = getWishlist();
      $(wl).each(function(){
        if(this.handle.localeCompare(handle) == 0 && this.variant == variant){
          var i = wl.indexOf(this);
          if(i>=0)
            wl.splice(i, 1);
        }
      });
      localStorage.setItem('wishlist', JSON.stringify(wl));
      saveWishlist(wl, function(){
        if(reload)
          location.reload();
        else
          wishlistSaved();
      });
    }

    function wishlistSaved(){
      $(btnAdd).toggleClass('d-none');
      $(btnRemove).toggleClass('d-none');
    }
  }
}

function announcement(){
  const bsAlert = new bootstrap.Alert('#announcement-bar');
  if(sessionStorage.getItem("announcement") !== null){
    bsAlert.close();
  }
  $('#announcement-bar').on('closed.bs.alert', function(){
    sessionStorage.setItem('announcement', 'true');
  });
}

function phoneInputs(){
  $('[data-phone-input]').each(function(){
    var phone = window.intlTelInput(this, {
      initialCountry: $(this).attr('data-phone-input'),
      separateDialCode: true,
      preferredCountries: ['IT', 'CH', 'US', 'GB', 'DE', 'FR'],
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });
  });
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          swipers();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function inArray(needle, haystack) {
  var length = haystack.length;
  for(var i = 0; i < length; i++) {
      if(haystack[i] == needle || haystack[i].localeCompare(needle) === 0) return true;
  }
  return false;
}

function photoSwipe(){
  $(function () {
    var pswpElement = document.querySelectorAll('.pswp')[0];
    var gallery;
    var items = [];
    var images = $('.product-single .zoom__img');

    if (!images.length) {      
      return;
    }
  
    images.each(function () {
      var img = $(this);
      var aspectRatio = parseFloat(img.attr('data-aspectratio'));     
      var zoomImg = img.attr('data-zoom-src');
      
      if (zoomImg) {
        items.push({
          src: zoomImg,
          w: 2000 * aspectRatio,
          h: 2000
        });
  
        img.on('click', function (e) {
          if (window.PREVENT_ZOOM) return;
          var index = images.index(this);
  
          var options = {
            index: index,
            zoomEl: true,
            shareEl: false,
            fullscreenEl: false,
            arrowKeys: true,
            counterEl: false,
            showHideOpacity: true,
          };
  
          gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
  
          // WORK AROUND to prevent background color error injected from Photoswipe in touchscreen devices.
          $('.pswp__top-bar').css('background', '#ffffff4d');
        });
      }
    });
  });
}

function announcementBar() {
  const $announcementBar = $('.announcement-bar');
  const $header = $('.section-header');
  
  if ($announcementBar.length > 0 && $announcementBar.children().length > 0) {
    const $firstAnnouncement = $announcementBar.find('.announcement-bar__announcement').first();
    var announcementHeight = parseInt($firstAnnouncement.innerHeight());
    $announcementBar.css('height', announcementHeight + 'px');
    $header.css('top', announcementHeight + 'px');

    if ($announcementBar.children().length > 1) {
      $firstAnnouncement.clone().attr('data-announcement-index', $announcementBar.children().length).appendTo($announcementBar);
      const $announcements = $announcementBar.find('.announcement-bar__announcement');

      $announcements.each(function () {
        $(this).css('height', announcementHeight + 'px');
      });

      var activeIndex = 0;
      var isPaused = false;  

      const scrollAnnouncements = () => {
        if (!isPaused) {  
          activeIndex++;
          if (!$announcementBar.find('[data-announcement-index="' + activeIndex + '"]').length > 0) {
            $announcements.each(function () {
              var transition = $(this).css('transition');
              $(this).css('transition', '0s');
              $(this).css('transform', 'translate3d(0, 0, 0)');

              setTimeout(() => {
                $(this).css('transition', transition);
              }, 0);
            });

            activeIndex = 1;
          }

          setTimeout(() => {
            $announcements.each(function () {
              if ($announcementBar.data('direction') === 'horizontal') {
                $(this).css('transform', 'translate3d(calc(' + activeIndex + ' * -100%), 0, 0)');
              } else {
                $(this).css('transform', 'translate3d(0, calc(' + activeIndex + ' * -100%), 0)');
              }
            });
          }, 0);
        }
      };

      const speedInSeconds = parseFloat($announcementBar.data('speed'));
      const intervalTime = speedInSeconds * 1000; 

      var intervalId = setInterval(scrollAnnouncements, intervalTime);

      $announcementBar.on('mouseover', function() {
        isPaused = true; 
      });

      $announcementBar.on('mouseleave', function() {
        isPaused = false; 
      });
    }
  }
}

if(document.querySelector('.section-richtext__description')){
  const richtext_content = document.querySelector('.section-richtext__description');
  const richtext_elements = richtext_content.querySelectorAll('h2, p');
  const richtext_toggleBtn = document.querySelector('.section-richtext__read-more');

  for (let i = 2; i < richtext_elements.length; i++) {
    richtext_elements[i].classList.add('hidden');
  }

  richtext_toggleBtn.addEventListener('click', function() {
    richtext_elements.forEach((el, index) => {
      if (index >= 2) {
        el.classList.toggle('hidden');
        el.classList.toggle('visible');
      }
    });

    if (richtext_toggleBtn.textContent === richtext_toggleBtn.getAttribute('data-read-less')) {
      richtext_toggleBtn.textContent = richtext_toggleBtn.getAttribute('data-read-more');
    } else {
      richtext_toggleBtn.textContent = richtext_toggleBtn.getAttribute('data-read-less');
    }
  });
}

window.addEventListener("resize", debounce(scrollVariant, 600));

